import { call, takeLatest, put, select } from 'redux-saga/effects';
import { isEqual } from 'lodash';
import { addToRootSaga } from 'store';
import { fetchCampaignContributions } from 'api/IterableGoalsAPI';

import { Saga } from 'custom-types/saga';
import {
  CampaignContributionQuery,
  CampaignContributionsAction,
  PaginationInput,
  SortInput,
} from 'modules/iterableGoals/types';
import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import { getCommonTranslations } from 'utils/translations';
import * as actions from 'modules/iterableGoals/ducks/actions';
import { ActionTypes } from 'modules/iterableGoals/ducks/actionTypes';
import { getCampaignContributionsState } from '../selectors';

// Temporary caching mechanism
let cachedQueryData: CampaignContributionQuery = {
  goalName: '',
  startTime: '',
  endTime: '',
  pagination: <PaginationInput>{},
  sort: <SortInput>{},
};

export function* fetchCampaignContributionsSaga({
  queryData,
}: CampaignContributionsAction<{
  queryData: CampaignContributionQuery;
}>): Saga<CampaignContributionsAction> {
  try {
    let { data: campaignContributionsData } = yield select(getCampaignContributionsState);

    const hasQueryDataChanged = !isEqual(queryData, cachedQueryData);

    if (hasQueryDataChanged) {
      const { data } = yield call(fetchCampaignContributions, queryData);
      campaignContributionsData = data.campaignStatsForGoal;

      // Updating the time range in local cache
      cachedQueryData = queryData;
    }

    yield put(actions.fetchCampaignContributionsResponse(campaignContributionsData));
  } catch (error) {
    const errorMessage = yield call(getCommonTranslations, 'errorMessage.contactCSM');
    yield put(actions.fetchCampaignContributionsError());
    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          source: 'fetchCampaignContributionsSaga',
          error,
          additional: queryData,
        }),
      ),
    );
  }
}

addToRootSaga([
  takeLatest(ActionTypes.FETCH_CAMPAIGN_CONTRIBUTIONS_REQUEST, fetchCampaignContributionsSaga),
]);
